import DropdownField from 'components/form-fields/formik/DropdownField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DropdownOption,
  TimeUnit,
  TimeUnitValues,
} from 'screens/GroupsAndPolicies/types';

export const TimeFormatField = (props: { name: string }) => {
  const { t } = useTranslation();

  return (
    <DropdownField
      name={props.name}
      selection
      required
      label={t('tariff.priceSelection.timeFormat', 'Format')}
      options={getTimeFormatOptions()}
    />
  );
};

const getTimeFormatOptions = (): DropdownOption<TimeUnit>[] => {
  const { t } = useTranslation();

  return TimeUnitValues.map((value) => ({
    key: value,
    value,
    text: t(`tariff.priceSelection.timeFormat.${value.toLowerCase()}`, value),
  }));
};
